import React, { PureComponent } from 'react'
import { Alert } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { checkSession, activateMfa, confirmMfa, checkMfaStatus, disableMfa, logoutUser } from '../actions'
import { requestPasswordResetCode, confirmPasswordReset } from '../actions/password_reset'
import { updateProfile } from '../actions/update_profile'
import { getUser } from '../actions/users'
import { DivContentBox, DivTitleBox } from '../components/common/styled'
import ProfileComponent from '../components/profile_component'
import Spinner3Bounce from '../components/spinner_3_bounce'

export class Profile extends PureComponent {
  componentDidMount() {
    const { getUser } = this.props
    getUser()
  }

  updateProfile = (profile) => this.props.updateProfile(profile)

  render() {
    const {
      errorMessage,
      isAuthenticated,
      isFetching,
      getUserFetching,
      user,
      updateProfileFetching,
      getUser,
      activateMfa,
      qrLink,
      confirmMfa,
      checkMfaStatus,
      mfaStatus,
      disableMfa,
      confirmMfaError,
      requestPasswordResetCode,
      confirmPasswordReset,
      logoutUser,
      isRequestingCode,
      isConfirming,
    } = this.props
    if (!isAuthenticated) {
      return null
    }

    if (isFetching || getUserFetching || !user) {
      return (
        <div className='text-center grid-spinner-mt-240'>
          <Spinner3Bounce isActive />
        </div>
      )
    }

    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <DivTitleBox className='ibox-title'>
          <div className='row'>
            <div className='col-md-12'>
              <ProfileComponent
                user={user}
                updateProfile={this.updateProfile}
                isFetching={updateProfileFetching || getUserFetching}
                getUser={getUser}
                activateMfa={activateMfa}
                confirmMfa={confirmMfa}
                qrLink={qrLink}
                checkMfaStatus={checkMfaStatus}
                mfaStatus={mfaStatus}
                disableMfa={disableMfa}
                confirmMfaError={confirmMfaError}
                requestPasswordResetCode={requestPasswordResetCode}
                confirmPasswordReset={confirmPasswordReset}
                logoutUser={logoutUser}
                isRequestingCode={isRequestingCode}
                isConfirming={isConfirming}
              />
            </div>
          </div>
        </DivTitleBox>
        <DivContentBox className='ibox-content'>
          <div>{errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}</div>
        </DivContentBox>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  qrLink: state.auth.qrLink,
  mfaStatus: state.auth.mfaStatus,
  confirmMfaError: state.auth.confirmMfaError,
  errorMessage: state.businesses.errorMessage,
  results: state.businesses.results,
  isFetching: state.businesses.isFetching,
  user: state.getUser.user,
  getUserFetching: state.getUser.isFetching,
  updateProfileFetching: state.updateProfile.isFetching,
  isRequestingCode: state.passwordReset.isRequestingCode,
  isConfirming: state.passwordReset.isConfirming,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      checkSession,
      getUser,
      updateProfile,
      activateMfa,
      confirmMfa,
      checkMfaStatus,
      disableMfa,
      requestPasswordResetCode,
      confirmPasswordReset,
      logoutUser,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Profile))
